import CallAPI from "@/functions/Cl_api";
import { Cl_common } from "@/functions/Cl_common";
import { DtoRequestTmppaysGetReqImple } from "furukawa-common/src/common/dto/DtoRequestTmppaysGetReqImple";
import { DtoRequestTmppaysGetResImple } from "furukawa-common/src/common/dto/DtoRequestTmppaysGetResImple";
import { DtoRequestTmppaysPostReq } from "furukawa-common/src/common/dto/abst/DtoRequestTmppaysPostReq";
import { DtoRequestTmppaysPostRes } from "furukawa-common/src/common/dto/abst/DtoRequestTmppaysPostRes";
import { DtoRequestTmppaysPutReq } from "furukawa-common/src/common/dto/abst/DtoRequestTmppaysPutReq";
import { DtoRequestTmppaysPutRes } from "furukawa-common/src/common/dto/abst/DtoRequestTmppaysPutRes";
import { DtoRequestTmppaysDeleteReq } from "furukawa-common/src/common/dto/abst/DtoRequestTmppaysDeleteReq";
import { DtoRequestTmppaysDeleteRes } from "furukawa-common/src/common/dto/abst/DtoRequestTmppaysDeleteRes";

export class Cl_requesttmppay {
  public static async getList(
    dto: DtoRequestTmppaysGetReqImple
  ): Promise<DtoRequestTmppaysGetResImple> {
    return Object.assign(
      new DtoRequestTmppaysGetResImple(),
      await CallAPI.getRequest(
        "/requestTmppays?" +
          Cl_common.cnvObj2GetParam(dto.pager) +
          "&" +
          Cl_common.cnvObj2GetParam(dto)
      )
    );
  }

  public static async get(
    dto: DtoRequestTmppaysGetReqImple
  ): Promise<DtoRequestTmppaysGetResImple> {
    return Object.assign(
      new DtoRequestTmppaysGetResImple(),
      await CallAPI.getRequest("/requestTmppays/" + dto.c_request_tmppay_id)
    );
  }

  public static async post(
    dto: DtoRequestTmppaysPostReq
  ): Promise<DtoRequestTmppaysPostRes> {
    return Object.assign(
      new DtoRequestTmppaysPostRes(),
      await CallAPI.postRequest("/requestTmppays", dto)
    );
  }

  public static async put(
    dto: DtoRequestTmppaysPutReq
  ): Promise<DtoRequestTmppaysPutRes> {
    return Object.assign(
      new DtoRequestTmppaysPutRes(),
      await CallAPI.putRequest(
        "/requestTmppays/" + dto.c_request_tmppay_id,
        dto
      )
    );
  }

  public static async del(
    dto: DtoRequestTmppaysDeleteReq
  ): Promise<DtoRequestTmppaysDeleteRes> {
    return Object.assign(
      new DtoRequestTmppaysDeleteRes(),
      await CallAPI.deleteRequest(
        "/requestTmppays?" + Cl_common.cnvObj2GetParam(dto)
      )
    );
  }
}
